<div class="flex flex-column h-full">
  <div class="overflow-y-auto">
    <ul class="list-none m-0">
      <li class="mb-6">
        <p-divider align="left" type="solid" class="menu-divider">
          <span>LIGAPADLA.PL</span>
        </p-divider>
        <app-menu-links [linksGroup]="linksGroup1"></app-menu-links>
      </li>
      <li class="mb-6">
        <p-divider align="left" type="solid" class="menu-divider">
          <span>PADEL</span>
        </p-divider>
        <app-menu-links [linksGroup]="linksGroup2"></app-menu-links>
      </li>
      <li>
        <p-divider align="left" type="solid" class="menu-divider">
          <span>BĄDŹ NA BIEŻĄCO</span>
        </p-divider>
        <app-menu-socials [socialsGroup]="socialsGroup"></app-menu-socials>
      </li>
    </ul>
  </div>
</div>
